import { Stack } from '@mui/material'
import type { AdminModel } from 'higgins-domain'

import { TextValueInput } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

export const ColorsSidebar = (props: {
  id: AdminModel.CabinetMaterial['id'] | AdminModel.CountertopMaterial['id']
}) => {
  const { id } = props

  return (
    <Stack gap={3}>
      <PropertyContainer.Group spacing="large">
        <PropertyContainer.Item title="Details">
          <Stack gap={2} sx={{ mt: 2 }}>
            <TextValueInput entityId={id} instanceName="name" label="Name" />
            <TextValueInput entityId={id} instanceName="color" label="#Hex" />
          </Stack>
        </PropertyContainer.Item>
      </PropertyContainer.Group>
    </Stack>
  )
}
